import Vue from "vue";
import App from "./App.vue";
import store from "./store/index.js";
import VueRouter from "vue-router";
import router from "./router/index";
import VueAnalytics from "vue-analytics";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import VueClipboard from 'vue-clipboard2'

// Slick Slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import i18n from "@/plugins/i18n.js";
import FlagIcon from "vue-flag-icon";
import ElementUI from "element-ui";
import "./assets/element-variables.scss";
import locale from "element-ui/lib/locale/lang/en";
import de from "vee-validate/dist/locale/de.json";
import VueLoading from "vue-loading-template";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from "vee-validate";

import * as rules from "vee-validate/dist/rules";
import Notifications from "vue-notification";
import VueBreadcrumbs from "vue-2-breadcrumbs";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VModal from "vue-js-modal";
import VueExcelXlsx from "vue-excel-xlsx";
import VueTables from "vue-crud-tables";
import numeral from "numeral";
require("numeral/locales/de");

import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VCalendar from "v-calendar";
import moment from "moment";
import VueHtmlToPaper from "vue-html-to-paper";
import Vuelidate from "vuelidate";

import VueZoomer from "vue-zoomer";
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://cdnjs.cloudflare.com/ajax/libs/tailwindcss/1.4.6/tailwind.min.css",
  ],
};

Vue.filter("filter-rating-date", (arg) => {
  if (arg === null) {
    return null;
  } else {
    return moment(arg, "YYYY-MM-DD").format("DD-MM-YYYY");
  }
});

//Google Analytics
Vue.use(VueAnalytics, {
  id: "UA-126632049-2",
  router,
});
//
import Toaster from 'v-toaster'
 
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'v-toaster/dist/v-toaster.css'
 
// optional set default imeout, the default is 10000 (10 seconds).
Vue.use(Toaster);

Vue.use(VueRouter);
Vue.use(FlagIcon);
Vue.use(ElementUI, { locale });
Vue.use(Notifications);
Vue.use(VueBreadcrumbs);
Vue.use(VModal);
Vue.use(VueExcelXlsx);
Vue.use(VueTables);
Vue.use(numeral);
Vue.use(VueFormWizard);
Vue.use(VueLoading);
Vue.use(VueClipboard);

// used in excel
Vue.use(VCalendar, {
  componentPrefix: "vc", // Use <vc-calendar /> instead of <v-calendar />
});

Vue.use(VueHtmlToPaper, options);
Vue.use(Vuelidate);

Vue.use(VueZoomer);
Vue.component("v-select", vSelect);

// install rules and localization
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

localize("de", de);

numeral.locale("de");
numeral.localeData("de").delimiters.thousands = ".";

//install components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.filter("formatNumber", function(value) {
  return numeral(value).format("0,0.00 $");
  // displaying other groupings/separators is possible, look at the docs
});

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.loggedIn) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

new Vue({
  store,
  router,
  i18n,
  PulseLoader,
  render: (h) => h(App),
}).$mount("#app");
